import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Table, Input, Upload, Button, Tooltip, message, InputNumber, TimePicker } from 'antd';

import SelectComponent from './SelectComponent';
import localStorage from '../../../../utils/localStorage';
import KeyComponent from './KeyComponent';
import { deleteFileUpload } from '../eLogCalls';

import styles from '../CSS/style.less';
import '../CSS/eLog.css';
import { EditOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { MASTER } from '../../../../commons/api.js';

const TableView = (props) => {

const [form,setForm] = useState(props.form || {});
let [columns,setColumns] = useState(props.form && props.form.columns ? props.form.columns : []);
const [,setModal] = useState(props.form && props.form.modal ? props.form.modal : []);
const [data,setData] = useState( props.form && props.form.datasource ? props.form.datasource.map((dataSource, index) => {
              return {
                ...dataSource,
                key: index + 1
              };
            })
          : []);
const [open,setOpen] = useState(false);
//const [mainHeaderValue,setMainHeaderValue] = useState(props.mainHeaderValue ? props.mainHeaderValue : {});
//const [subHeaderValue,setSubHeaderValue] = useState(props.subHeaderValue ? props.subHeaderValue : {});
const [optionList,setOptionList] = useState([]);     
const [loading,setLoading] = useState(false);
let clickedCancel = useRef(false);
const cacheOriginData = useRef({});

useEffect(() => {
   const fetchOptionList = async() => {
    let optionList = [];
    if (
      props.form.columns[0] &&
      props.form.columns[0].table &&
      props.form.columns[0].table.responseType
    ) {
      optionList = await getDropdownList(props.form.columns[0]);
      setOptionList(optionList);

       let columns = generateColumns(
      props.form && props.form.columns ? props.form.columns : [],
      props.mainHeaderValue ? props.mainHeaderValue : {},
      props.subHeaderValue ? props.subHeaderValue : {}
    );
    setForm(props.form);
    setColumns(columns);
    setModal(props.form && props.form.modal ? props.form.modal : []);
    setData( props.form && props.form.datasource
          ? props.form.datasource.map((dataSource, index) => {
              return {
                ...dataSource,
                key: index + 1
              };
            })
          : []);
    }
   };
   fetchOptionList();
},[]);

useEffect(() => {
    let columns = generateColumns(
        props.form.columns,
        props.mainHeaderValue,
        props.subHeaderValue
      );
      setForm(props.form);
      setColumns(columns);
      setData(props.form && props.form.datasource
            ? props.form.datasource.map((dataSource, index) => {
                return {
                  ...dataSource,
                  key: index + 1
                };
              })
            : []);
},[props.form,props.mainHeaderValue,props.subHeaderValue]);

  const getDropdownList = (column) => {
    
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let objectHeader = {
      method: column.table.method,
      url: `${column.table.url}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: column.table.payload
    };
    return axios(objectHeader).then((response) => {
      if (Array.isArray(response.data)) {
        return response.data;
      }
    });
  };

  const generateColumns = (columns, mainHeaderValue, subHeaderValue) => {
 
    let { translationCache } = props;

    let finalColumns = [];
    if (columns && columns.length > 0) {
      finalColumns = columns.map((column) => {
        return {
          title:
            translationCache && translationCache[column.title]
              ? translationCache[column.title]
              : column.title,
          dataIndex: column.key || 0,
          key: column.key || 0,
          width: column.width,
          widget: column.widget,
          required: column.required,
          table: column.table || {},
          render: (text, record) => {
            if (record.editable) {
              return renderWidget(
                column,
                text,
                record,
                columns,
                mainHeaderValue,
                subHeaderValue
              );
            }

            if (Array.isArray(text)) {
              return text.map((file, index) => {
                return (
                  <div key={index}>
                    <a href={file.url}>{file.name}</a>
                  </div>
                );
              });
            } else if (column.widget === 'timePicker') {
              return text;
            } else if (column.key === 'name') {
              return (
                <div>
                  <a
                    style={{ color: '#062d57' }}
                    href={record.base64}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {text}
                  </a>
                </div>
              );
            } else if (
              column &&
              column.table &&
              column.table.responseType &&
              column.table.responseType === 'arrayOfObject'
            ) {
              let filteredObject = [];
              optionList &&
                Array.isArray(optionList) &&
                optionList.filter((optionData) => {
                  if (optionData.Value === text) {
                    filteredObject.push(optionData.Key);
                  }
                  return {};
                });
              return filteredObject && filteredObject[0] ? filteredObject[0] : text;
            } else {
              return text && text !== 'null' ? text : '';
            }
          }
        };
      });
    }
    return finalColumns;
   
    
  };

  const deleteFile = async (file) => {
    if (file && file.response && file.response.name) {
      await deleteFileUpload(file.response.name);
      message.success('File Deleted');
    } else {
      message.error('Error deleting file');
    }
  };

  const onFileChange = (info, column, text, record) => {
    if (info.file.status === 'done') {
      let fieldValue = [];
      if (text && Array.isArray(text) && text !== undefined) {
        fieldValue = [...text, info.file.response];
      } else if (!text) {
        fieldValue = [info.file.response];
      }
      handleFieldChange(fieldValue, column.key, record.key);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    } else if (info.file.status === 'removed') {
      deleteFile(info.file);
      handleFieldChange(info.fileList, column.key, record.key);
    }
  };

  const renderWidget = (column, text, record, columns, mainHeaderValue, subHeaderValue) => {
    
    const token = localStorage.get('accessToken');
    let defaultFileList = text && Array.isArray(text) ? text : [];
    var Authorization = 'Bearer ' + token;
    const renderProps = {
      name: 'file',
      action: `${MASTER.FileUpload}`,
      headers: {
        Authorization: Authorization
      },
      defaultFileList
    };
    switch (column.widget) {
      case 'input':
        return (
          <Input
            autoFocus
            value={text && text !== 'null' ? text : ''}
            style={{ width: '300px', fontWeight: 'bold' }}
            onChange={(e) => handleFieldChange(e.target.value, column.key, record.key)}
            maxLength={columns && columns.maxLength ? columns.maxLength : 100}
            onKeyPress={(e) => handleKeyPress(e.target.value, record.key)}
            placeholder={column.placeHolder || column.displayName}
            disabled={column.disable ? column.disable : false}
          />
        );
      case 'inputNumber':
        return column.widgetCondition &&
          column.widgetCondition === true &&
          record.widget !== undefined &&
          record.widget !== true ? (
          <InputNumber value="" disabled style={{ width: '90%', fontWeight: 'bold' }} />
        ) : (
          <InputNumber
            value={text}
            style={{ width: '300px', fontWeight: 'bold' }}
            onBlur={(e) =>
              inputNumberChange(column.min, column.max, e.target.value, column.key, record.key)
            }
            onChange={(e) =>
              handleFieldChange(e, column.key, record.key, column.min, column.max)
            }
            onKeyPress={(e) => handleKeyPress(e.target.value, record.key)}
            placeholder={column.placeHolder || column.displayName}
          />
        );
      case 'textComponent':
        return (
          <KeyComponent
            data={data}
            column={column}
            record={record}
            text={text}
            datasource={mainHeaderValue ? mainHeaderValue : {}}
            subdatasource={subHeaderValue ? subHeaderValue : {}}
            handleDataChange={handleDataChange}
          />
        );
      case 'text':
        return TextComponent(text, columns);

      case 'select':
        return (
          <SelectComponent
            data={data}
            column={column}
            record={record}
            text={text}
            datasource={mainHeaderValue ? mainHeaderValue : {}}
            subdatasource={subHeaderValue ? subHeaderValue : {}}
            handleFieldChange={handleFieldChange}
            handleKeyPress={handleKeyPress}
          />
        );
      case 'upload':
        return (
          <Upload
            {...renderProps}
            onChange={(info) => onFileChange(info, column, text, record)}
          >
            <Button>
              <UploadOutlined /> Upload
            </Button>
          </Upload>
        );
      case 'timePicker':
        return (
          <TimePicker
            format="HH:mm:ss"
            value={text && text !== 'Invalid date' ? moment(text, 'HH:mm:ss') : undefined}
            style={{ width: 300 }}
            disabled={columns.disable ? columns.disable : false}
            onChange={(e) => handleFieldChange(e, column.key, record.key)}
            onOpenChange={() => setOpen(true)}
            open={open}
            addon={() => (
              <Button size="small" type="primary" onClick={() => setOpen(false)}>
                Ok
              </Button>
            )}
          />
        );
      default:
        return text;
    }
  };
  
  const TextComponent = (text) => {
  
    let optionFiltered =
      optionList &&
      Array.isArray(optionList) &&
      optionList.filter((option) => {
        return option.Value === text;
      });
    return optionFiltered && optionFiltered[0] && optionFiltered[0].Key
      ? optionFiltered[0].Key
      : text;
  };

  const saveRow = (e, key, record)  => {
    e.persist();
    setLoading(false);
    if (clickedCancel) {
      clickedCancel = false;
      return;
    }
    const target = getRowByKey(key) || {};
    let checkReqField = false;
    columns &&
      Array.isArray(columns) &&
      columns.map((columnsObject) => {
        if (
          columnsObject['required'] &&
          (columnsObject['required'] === 'true' || columnsObject['required'] === true)
        ) {
          if (
            target[columnsObject.key] ||
            (target[columnsObject.key] === 0 && target[columnsObject.key] !== '') ||
            (record && record.widget === false)
          ) {
            return {};
          } else {
            e.target.focus();
            checkReqField = true;
          }
        }
        return {};
      });
    if (checkReqField) {
      message.warn('Please fill in the complete information');
    } else {
      saveToggleEditable(e, key);
      setLoading(false);
    }
  };

 const editRow = (key) =>{
    toggleEditable(key);
  };

  // const cancel = (e, key) => {
  //   clickedCancel = true;
  //   e.preventDefault();
  //   const newData = data.map((item) => ({ ...item }));
  //   const target = getRowByKey(key, newData);
  //   if (cacheOriginData !== undefined) {
  //     if (cacheOriginData[key]) {
  //       Object.assign(target, cacheOriginData[key]);
  //       delete cacheOriginData[key];
  //     }
  //   }
  //   target.editable = false;
  //   setData(newData);
  //   clickedCancel = false;
  // }

  const getRowByKey = (key, newData) => {
    return (newData || data).filter((item) => item.key === key)[0];
  };

  const saveToggleEditable = (e, key) => {
    e.preventDefault();
   
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(key, newData);
    if (target) {
      if (!target.editable && cacheOriginData) {
        cacheOriginData[key] = { ...target };
      }
      target.editable = !target.editable;
      setData(newData);
      props.saveTableViewData(newData);
    }
  };

  const toggleEditable = (key) => {
   
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(key, newData);
    if (target) {
      target.editable = !target.editable;
      setData(newData);
      props.saveTableViewData(newData);
    }
  };
  // const remove = (key) =>{
   
  //   if (key.isNew) {
  //     const newData = data.filter((item) => item.key !== key.key);
  //     setData(newData);
  //   } else {
  //     message.error('Cant delete this record..');
  //   }
  // }

  const handleKeyPress = (e, key) => {
    if (e.key === 'Enter') {
      saveRow(e, key);
    }
  };

  const inputNumberChange = (minValue, maxValue, value, key, record) => {
    if (
      value >= minValue &&
      value <= maxValue &&
      minValue !== undefined &&
      maxValue !== undefined
    ) {
      handleFieldChange(value, key, record, minValue, maxValue);
    } else if (minValue === undefined && maxValue === undefined) {
      handleFieldChange(value, key, record, minValue, maxValue);
    } else {
      handleFieldChange('', key, record, minValue, maxValue);
      message.error(`The input range must between ${minValue} and ${maxValue}`);
    }
  };
  const handleFieldChange = async (fieldValue, fieldName, keyValue, min) => {
    
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(keyValue, newData);
    if (min !== undefined && min > 0 && typeof fieldValue === 'number' && fieldValue < 0) {
      message.error('Please Input Positive Values  Only');
      target[fieldName] = '';
      setData(newData);
    } else if (min === undefined && typeof fieldValue === 'number' && fieldValue < 0) {
      message.error('Please Input Positive Values  Only');
      target[fieldName] = '';
      setData(newData);
    } else {
      if (target) {
        if (fieldName === 'StartTime') {
          target[fieldName] = moment(fieldValue).format('HH:mm:ss');
        } else {
          target[fieldName] = fieldValue;
        }
        setData(newData);
      }
    }
  };

  const handleDataChange = (fieldValue, fieldName) => {
   
    const newData = data.map((item) => ({ ...item }));
    if (newData) {
      newData.map((item, key) => {
        newData[key][fieldName] = fieldValue;
        return {};
      });
      setData(newData);
    }
    props.saveTableViewData(newData);
  };

  const addRow = () => {
    let dataLength;
    dataLength = data.length + 1;
    let newdata = {
      key: dataLength,
      SNo: dataLength,
      editable:true
    };
    data.push(newdata);
    setData(data);
    props.saveTableViewData(data);
  };

    const {translationCache } = props;
    //let { action } = form; 
    
    if (form && form.columns) {
      if (!props.status) {
        columns = [
          ...columns,
          {
            title:
              translationCache && translationCache['Action']
                ? translationCache['Action']
                : 'Action',
            key: 'action',
            render: (text, record) => {
              if (!!record.editable && loading) {
                return null;
              }
              if (record.editable) {
                if (record.isNew) {
                  return (
                    <span>
                      <Tooltip placement="top" trigger="hover" title={'Save'}>
                        <Button onClick={(e) => saveRow(e, record.key, record)}>
                          <SaveOutlined
                            style={{ fontSize: '20px', color: '#193652' }}
                            type="save"
                          />
                        </Button>
                      </Tooltip>
                    </span>
                  );
                }
                return (
                  <span>
                    <Button onClick={(e) => saveRow(e, record.key, record)}>
                      <SaveOutlined style={{ fontSize: '20px', color: '#193652' }} type="save" />
                    </Button>
                  </span>
                );
              } else {
                return (
                  <span>
                    <Button onClick={(e) => editRow(record.key, e)}>
                      <EditOutlined style={{ fontSize: '20px', color: '#193652' }} type="edit" />
                    </Button>
                  </span>
                );
              }
            }
          }
        ];
      }
    }
    return (
      <div className="tableView">
        <div>
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={false}
            style={{ marginTop: '10px', border: '1px solid  red !important' }}
            rowClassName={(record) => (record.editable ? styles.editable : '')}
          />
          {form && form.showAddButton? (
            <Button
              //type="primary"
              style={{ marginTop: '10px' }}
              onClick={addRow}
              disabled={props.status && props.status === 'Completed' ? true : false}
            >
              {translationCache && translationCache['Add Row'] && translationCache['Add Row']
                ? translationCache['Add Row']
                : 'Add Row'}
            </Button>
          ) : null}
        </div>
      </div>
    );
  };


export default TableView;
